import { TTableSort } from 'src/components/table/thead/col';

import { TProductOrderListSortCol } from './product-order.type';


export type TAccountProductOrderListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TProductOrderListSortCol;
};

export type TAccountProductOrderListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptAccountProductOrderListQueryToRequest(data?: TAccountProductOrderListQuery): TAccountProductOrderListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TAccountProductOrderPayloadRequest = {
  productId: string | number;
  serialNumber: string;
  name: string;
  storageId: string;
  storageName: string;
  amount: number;
  amountType: string;
  amountMultiplicity: number;
  price: number;
  isReturnable: boolean;
  providerId: number;
  brandId: number;
  orderAmount: number;
};

export type TAccountProductOrderRequest = {
  product_id: string | number;
  serial_number: string;
  name: string;
  storage_id: string;
  storage_name: string;
  amount: number;
  amount_type: string;
  amount_multiplicity: number;
  price: number;
  is_returnable: boolean;
	provider_id: number;
  brand_id: number;
  order_amount: number;
};

export function adaptAccountProductOrderToRequest(data: TAccountProductOrderPayloadRequest): TAccountProductOrderRequest {
	const {
		productId,
		serialNumber,
		name,
		storageId,
		storageName,
		amount,
		amountType,
		amountMultiplicity,
		price,
		isReturnable,
		providerId,
		brandId,
		orderAmount,
	} = data;

	return {
		product_id: productId,
		serial_number: serialNumber,
		name: name,
		storage_id: storageId,
		storage_name: storageName,
		amount: amount,
		amount_type: amountType,
		amount_multiplicity: amountMultiplicity,
		price: price,
		is_returnable: isReturnable,
		provider_id: providerId,
		brand_id: brandId,
		order_amount: orderAmount,
	};
}

export type TProductOrderPayloadRequest = {
	idList: number[];
	clientId?: number;
};

export type TProductOrderIdListRequest = {
  id_list: number[];
  client_id?: number;
};

export function adaptAccountProductOrderIdListToRequest(payload: TProductOrderPayloadRequest): TProductOrderIdListRequest {
	const { idList, clientId } = payload;

	return {
		id_list: idList,
		client_id: clientId || undefined,
	};
}
